export default __webpack_public_path__ + "static/media/SpotifyLogo.e2cf9485.png";